import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SatisfactionAnswerType } from '../../../../shared/live-class-survey/live-class-survey-data-types';

@Component({
  selector: 'lp2-liveclass-survey-selector',
  templateUrl: './liveclass-survey-selector.component.html',
  styleUrls: ['./liveclass-survey-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LiveclassSurveySelectorComponent),
      multi: true
    }
  ]
})
export class LiveclassSurveySelectorComponent implements ControlValueAccessor {
  @Input()
  public isLoading = false;

  public value: SatisfactionAnswerType;
  public disabled: boolean = false;
  public satisfactionAnswerType = SatisfactionAnswerType;

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  public valueChanged(value: SatisfactionAnswerType) {
    if (this.disabled) {
      return;
    }
    this.value = value;
    this.onChange(value);
  }

  public writeValue(value: any): void {
    this.value = value;
    this.cdRef.detectChanges();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/liveclass-survey/liveclass-survey-selector/liveclass-survey-selector.component.ts